import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { TaskDetailsHeaderComponent } from '@app/components/task/task-splitview-list/task-details-content/task-details-header/task-details-header.component';
import { TaskDetailsMetadataPanelComponent } from '@app/components/task/task-splitview-list/task-details-content/task-details-metadata-panel/task-details-metadata-panel.component';
import {
  TASK_DETAILS_TABS,
  TaskDetailsTab
} from '@app/components/task/task-splitview-list/task-details-content/task-details-tab.enum';
import { TaskType } from '@app/shared/types/models/task/task-type.model';
import { Task } from '@app/shared/types/models/task/task.model';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiDetailPanelComponent } from '@app/shared/ui/detail-panel/ui-detail-panel.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TaskDetailsViewSettingsComponent } from '../task-details-view-settings.component';

/**
 * PROPOZYCJA — DO WERYFIKACJI
 *
 * @summary Wide (desktop) physical screen for the task details panel. Stateless presentational
 * component: it renders the wide layout (detail panel, header slots, metadata, tabs) and
 * projects the tab/subtasks content supplied by {@link TaskDetailsContentComponent} via
 * `TemplateRef`. All interactions are forwarded as outputs to the parent controller, which owns
 * business logic, state, and effects. The host fills the available height of the parent's sized
 * container so `UiDetailPanelComponent` and the subtasks section keep their existing sizing
 * (including the `cqh` container-query reference, which still resolves against the parent host).
 * @selector proffeo-task-details-wide-screen
 */
@Component({
  selector: 'proffeo-task-details-wide-screen',
  templateUrl: './task-details-wide-screen.component.html',
  styleUrl: './task-details-wide-screen.component.scss',
  host: {
    class: 'flex w-full min-w-0 min-h-0 flex-1 flex-col gap-2'
  },
  imports: [
    NgTemplateOutlet,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    TranslatePipe,
    UiButtonComponent,
    UiDetailPanelComponent,
    TaskDetailsHeaderComponent,
    TaskDetailsMetadataPanelComponent,
    TaskDetailsViewSettingsComponent
  ]
})
export class TaskDetailsWideScreenComponent {
  protected readonly taskTabs = TASK_DETAILS_TABS;

  public readonly task = input.required<Task>();
  public readonly taskTypes = input.required<TaskType[]>();
  public readonly taskActionsMenu = input.required<MatMenu>();
  public readonly isNameEditing = input.required<boolean>();
  public readonly maxTaskNameLength = input.required<number>();
  public readonly currentTabIndex = input.required<TaskDetailsTab>();
  public readonly tabContent = input.required<TemplateRef<unknown>>();
  public readonly subtasksContent = input.required<TemplateRef<unknown>>();
  public readonly showReopenActivity = input(false);

  public readonly closeRequested = output<void>();
  public readonly nameEditRequested = output<void>();
  public readonly nameEditCancelled = output<void>();
  public readonly taskNameChanged = output<string>();
  public readonly taskTypeSelected = output<TaskType>();
  public readonly timeReportRequested = output<Task>();
  public readonly timeReportsTabRequested = output<void>();
  public readonly tabSelected = output<{ index: TaskDetailsTab; event: MouseEvent }>();
  public readonly activityReopenRequested = output<void>();

  protected onTabClick(index: TaskDetailsTab, event: MouseEvent): void {
    this.tabSelected.emit({ index, event });
  }
}
